import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tabs } from 'antd';
import { FileDoneOutlined, ProfileOutlined } from '@ant-design/icons';

import Layout from '../Layout/index';
import ErrorBoundary from '../../components/Utils/ErrorBoundary';
import Payslips from './Payslips';
import Payments from './Payments';
import PayslipView from './payslipView';
import {
  gotoPayslipTab,
  removePayslipTab,
} from '../../store/reducers/payrollSlice';

const { TabPane } = Tabs;

const Payroll = ({ match, history }) => {
  const { user } = useSelector((state) => state.login);
  const { gridTabs, activeTabIndex } = useSelector((state) => state.payroll);
  const dispatch = useDispatch();

  const TabProps = {
    onTabClick: (key, e) => {
      console.log('onTabClick ///', key);
      dispatch(gotoPayslipTab({ key }));
    },
    onEdit: (key, action) => {
      console.log('onEdit ///', key, action);
      dispatch(removePayslipTab({ key }));
    },
  };

  return (
    <Layout title="Payroll">
      <Tabs
        defaultActiveKey={
          typeof match.params !== 'undefined' &&
          typeof match.params.tab !== 'undefined'
            ? match.params.tab
            : 'payslips'
        }
        type="editable-card"
        size="medium"
        key={
          typeof match.params !== 'undefined' &&
          typeof match.params.tab !== 'undefined'
            ? match.params.tab
            : 'payslips'
        }
        className="expenseTab"
        hideAdd
        onChange={(key) => {
          history.push(`/payroll/${key}`);
        }}
        activeKey={activeTabIndex ? activeTabIndex : 'payslips'}
        onTabClick={TabProps.onTabClick}
        onEdit={TabProps.onEdit}
      >
        {user && user.ability.toListPayslips && (
          <TabPane
            tab={
              <span>
                <ProfileOutlined />
                Payslips
              </span>
            }
            key="payslips"
            closable={false}
          >
            <ErrorBoundary>
              <Payslips gridId="payslips" />
            </ErrorBoundary>
          </TabPane>
        )}
        {user && user.ability.toListPayments && (
          <TabPane
            tab={
              <span>
                <FileDoneOutlined />
                Payments
              </span>
            }
            key="payments"
            closable={false}
          >
            <ErrorBoundary>
              <Payments gridId="payments" />
            </ErrorBoundary>
          </TabPane>
        )}
        {gridTabs &&
          gridTabs.map((tab) => {
            return (
              <TabPane
                tab={<span>{tab.title} &nbsp;&nbsp;</span>}
                key={tab.key}
                closable={tab.closable}
              >
                <PayslipView payslipId={tab.data} />
              </TabPane>
            );
          })}
      </Tabs>
    </Layout>
  );
};

export default Payroll;
